<template>
  <div id="materiaPrima">
    <v-data-table
      v-model="produtos_selecionados"
      :headers="headers"
      :items="PRODUTOS_FILTRADOS"
      item-key="idproduto"
      show-expand
      single-expand
      fixed-header
      show-select
      class="table-full-screen"
      :item-class="item => ({'text-red': item.fora_linha})"
      height="calc(100vh - 245px)"
      :items-per-page="50"
      :footer-props="{
        'items-per-page-options': [50, 100, 150],
      }"
    >
      <template #top>
        <div class="d-flex align-center px-2 pb-1 pt-2">
          <v-icon size="22">mdi-format-list-bulleted</v-icon>
          <span class="ml-1 font-18">Lista de produtos acabados</span>

          <v-divider class="mx-4" vertical/>

          <v-spacer />

          <div class="w-400">
            <v-text-field
              v-model="pesquisa"
              append-icon="mdi-magnify"
              label="Pesquisar"
              single-line
              dense
              outlined
              clearable
              hide-details
              v-lazy-input:debounce="500"
            />
          </div>

          <v-badge
            v-if="produtos_selecionados.length"
            color="white"
            :value="produtos_selecionados.length"
            overlap
          >
            <template #badge>
              <span class="text-black">{{ produtos_selecionados.length }}</span>
            </template>

            <v-btn color="error" class="ml-5" @click="excluirProdutosAcabado">
              <v-icon left>mdi-delete</v-icon>
              Excluir
            </v-btn>
          </v-badge>

          <Cadastro
            :item_para_edicao="item_para_edicao"
            @resetar-item-edicao="item_para_edicao = {}"
            @salvo-sucesso="buscarListaProdutosAcabado()"
          />
        </div>
      </template>

      <template #item.data-table-expand="{ expand, isExpanded }">
        <v-btn icon small @click="expand(! isExpanded)">
          <v-icon v-if="isExpanded">mdi-chevron-down</v-icon>
          <v-icon v-else>mdi-chevron-right</v-icon>
        </v-btn>
      </template>

      <template #item.qtde_materias_primas="{ item }">
        {{ item.materias_primas.length }}
      </template>

      <template #item.fora_linha="{ item }">
        {{ item.fora_linha ? 'Sim' : 'Não' }}
      </template>

      <template #item.ativo_venda="{ item }">
        {{ item.ativo_venda ? 'Sim' : 'Não' }}
      </template>

      <template #item.acoes="{ item }">
        <div class="d-flex">
          <v-btn icon small @click="item_para_edicao = Object.assign({}, item)">
            <v-icon size="22">mdi-pencil</v-icon>
          </v-btn>

          <v-btn
            v-if="item.utilizado_por_categoria"
            icon small color="#CACACA"
            :title="item.utilizado_por_categoria ? 'Produto acabado está vinculada a uma categoria de compra, por isso não pode ser excluído.' : ''"
          >
            <v-icon>mdi-delete-forever</v-icon>
          </v-btn>

          <v-btn v-else icon small @click="excluirProdutosAcabado(item)">
            <v-icon>mdi-delete</v-icon>
          </v-btn>
        </div>
      </template>

      <template #expanded-item="{ headers, item }">
        <td :colspan="headers.length" class="pb-5">
          <div class="pl-4">
            <div class="d-flex align-center pb-1 pt-2">
              <v-icon size="20">mdi-format-list-bulleted</v-icon>
              <span class="ml-1 font-16">Lista de matérias prima</span>
            </div>

            <v-simple-table dense>
              <template #default>
                <thead>
                  <tr>
                    <th class="text-left">Id Produto</th>
                    <th class="text-left">Descrição Produto</th>
                    <th class="text-left">Fator</th>
                    <th class="text-left">Fora de linha</th>
                  </tr>
                </thead>

                <tbody>
                  <tr v-for="item in item.materias_primas" :key="item.idproduto" :class="{'text-red': item.fora_linha}">
                    <td>{{ item.idproduto }}</td>
                    <td>{{ item.descricao_produto }}</td>
                    <td>{{ `${Helpers.formatarValorComCasas(item.peso_pa, 4)} ${item.idunidade_medida}` }}</td>
                    <td>{{ item.fora_linha ? 'Sim' : 'Não'}}</td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </div>
        </td>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import {buscarListaFichaTecnicaProdutoAcabado, excluirFichaTecnicaProdutoAcabado} from "@/api/fichaTecnicaProducao";
import Cadastro from "@/components/fichaTecnicaProducao/ProdutoAcabado/Cadastro";
import {mapGetters} from "vuex";
import {logout} from "@/helpers";

export default {
  components: {
    Cadastro
  },
  data: () => ({
    produtos_selecionados: [],
    produtos: [],
    headers: [
      {text: '', value: 'data-table-expand', width: 20},
      {text: 'Id Fornecedor', value: 'idfornecedor'},
      {text: 'Descrição Fornecedor', value: 'razao_social'},
      {text: 'Id Produto', value: 'idproduto'},
      {text: 'Descrição Produto', value: 'descricao_produto'},
      {text: 'Qtd. matérias primas', value: 'qtde_materias_primas'},
      {text: 'Data Cadastro', value: 'data_cadastro'},
      {text: 'Fora de linha', value: 'fora_linha'},
      {text: 'Ativo para revenda', value: 'ativo_venda'},
      {text: 'Ações', value: 'acoes', sortable: false}
    ],
    pesquisa: '',
    item_para_edicao: {}
  }),
  created() {
    this.buscarListaProdutosAcabado()
  },
  computed: {
    ...mapGetters({
      grupoCompra: "usuario/getGrupoCompras"
    }),
    PRODUTOS_FILTRADOS() {
      if (!this.pesquisa || !this.pesquisa.length) {
        return this.produtos;
      }

      const callback_objeto_para_string = (a, b) => {
        return `${a} ${Object.values(b).toString()}`;
      };

      const pesquisa_array = this.pesquisa.toUpperCase().trim().split(' ');

      const callback_filtro  = item => {
        const materias_primas_txt = item.materias_primas.reduce(callback_objeto_para_string, '');
        const produto_acabado_txt = Object.values({...item, materias_primas: ''}).toString();
        const txt_total = `${materias_primas_txt}${produto_acabado_txt}`.toUpperCase();

        return pesquisa_array.some(palavra => txt_total.includes(palavra));
      };

      return this.produtos.filter(callback_filtro);
    }
  },
  methods: {
    buscarListaProdutosAcabado(){
      this.$store.dispatch('loading/addRequisicao',
        buscarListaFichaTecnicaProdutoAcabado()
          .then(produtos => this.produtos = produtos).catch(logout)
      );
    },
    excluirProdutosAcabado(item) {
      const produtos = item.idproduto
        ? [`${item.idproduto}`]
        : this.Helpers.arrayColumn(this.produtos_selecionados, 'idproduto');

      this.$store.dispatch('loading/addRequisicao',
        excluirFichaTecnicaProdutoAcabado({produtos})
          .then(() => {
            this.produtos_selecionados = [];
            this.buscarListaProdutosAcabado();
          }).catch(logout)
      );
    }
  }
}
</script>

<style scoped>
</style>
